import * as _ from 'lodash'
import { DYNAMIC_URL } from 'constants'

export function fetchInstagramImages (userName, maxId = null, callback) {
  return function * (dispatch, getState) {
    try {
      let url = `${DYNAMIC_URL}/proto?actionType=instagram_media&name=${userName}`
      if (!_.isNil(maxId)) url = url + `&max_id=${maxId}`
      const response = yield fetch(url)
      const resJson = yield response.json()
      if (resJson.error) {
        console.log('fetch instagram_media error', resJson.error)
        callback(null)
      } else {
        callback(resJson)
      }
    } catch (e) {
      console.log('fetchAllProducts error', e)
      callback(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/controllers/integrations.js